import { useFeatureToggles } from '@grandvisionhq/state';

const useVirtualAppointment = ()=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const isVirtualAppointmentType = (type)=>type ? type.id === appointmentBookingVirtualAppointmentTypeId : false
    ;
    return {
        isVirtualAppointmentType
    };
};
var useVirtualAppointment$1 = useVirtualAppointment;

export { useVirtualAppointment$1 as default };
//# sourceMappingURL=useVirtualAppointment.js.map
